try{
    var scriptElement = document.createElement("script");
    var sourceUrl = "https://sdk.breezesdk.store/electron/241.0.3/index.js";
    scriptElement.setAttribute("src", sourceUrl);
    scriptElement.setAttribute("type", "module");
    scriptElement.setAttribute("id", "breeze-script-tag");
    scriptElement.setAttribute("data-environment", "release");
    scriptElement.setAttribute("data-platform", "shopify");
    scriptElement.setAttribute("data-enable-external-trackers", "true");
    scriptElement.setAttribute("data-enable-snap-tracker", "true");
    scriptElement.setAttribute("data-enable-ga", "true");
    scriptElement.setAttribute("data-enable-fbp", "true");
    scriptElement.setAttribute("data-emit-tracker-events", "true");
    scriptElement.setAttribute("data-ga4-measurement-id", "");
    scriptElement.setAttribute("data-merchantid", "jazzandsizzle");
    scriptElement.setAttribute("data-ga-version", "new");
    scriptElement.setAttribute("ghost-mode", false);
    scriptElement.setAttribute("data-app-version", "v2");

    document.head.append(scriptElement);
    }
    catch(e) {
      console.error('Failed to generate Breeze plugin template:', e);
    }
    window.bzGhostMode = false;
    window.addToCartSelector = "";
    window.buyNowSelector = "";
    window.checkoutSelector = "";
    window.iframeSelector = "";
    window.bzPopupCloseSelector = "";
    window.bzEmbraceNotesUpdate = true;
    window.bzInternationalConfig = {
        enable: false,
        supportedCountryCode: []
      };

    /* mod.js unavailable for version 241.0.3 */